import { render, staticRenderFns } from "./DialpadPanel.vue?vue&type=template&id=5b15b57d&scoped=true"
import script from "./DialpadPanel.vue?vue&type=script&lang=js"
export * from "./DialpadPanel.vue?vue&type=script&lang=js"
import style0 from "./DialpadPanel.vue?vue&type=style&index=0&id=5b15b57d&prod&lang=scss"
import style1 from "./DialpadPanel.vue?vue&type=style&index=1&id=5b15b57d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15b57d",
  null
  
)

export default component.exports